import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import VStack from '@/components/Layout/VStack';
import { InboundAggregateDataPipelineDetailHeader } from './-layout/InboundAggregateDataPipelineDetailHeader';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail')({
  component: Layout
});
function Layout() {
  return <VStack>
      <Suspense>
        <InboundAggregateDataPipelineDetailHeader />
      </Suspense>
      <Outlet />
    </VStack>;
}